import React, { useState } from 'react';

const HT = {
  yellow: '#FFD166', yellowSoft: '#FFE9A8', yellowBg: '#FFF8E7',
  green: '#88C057', greenDark: '#5E9E3E', greenSoft: '#D4E8C0', greenBg: '#E8F3D9',
  coral: '#FF8C42', coralDark: '#E76F51', coralPress: '#B8431E',
  pinkBg: '#FCE4E8', pink: '#F4A6B8',
  brown: '#8B6F47', brownDark: '#6B4F2B',
  text: '#2D2D2D', textSoft: '#6B6B6B', textMuted: '#9A9A9A',
  border: '#E8E0CC', white: '#FFFFFF',
};
const FONT_DISPLAY = '"Fredoka", "Baloo 2", "Nunito", sans-serif';
const FONT_BODY = '"Nunito", "Baloo 2", sans-serif';

export default function TrueFalseGame({ payload, onAnswer, disabled }) {
  const [submitted, setSubmitted] = useState(null);
  const truth = payload.is_correct;
  const isLocked = submitted !== null || disabled;

  const click = (userSaysTrue) => {
    if (isLocked) return;
    setSubmitted(userSaysTrue);
    if (onAnswer) onAnswer({
      is_correct: userSaysTrue === truth,
      user_answer: userSaysTrue,
    });
  };

  const isGrammarSentence = !!payload.sentence;

  return (
    <div style={{ maxWidth: 640, margin: '0 auto', fontFamily: FONT_BODY }}>
      <div style={{
        marginBottom: 14, textAlign: 'center',
        fontSize: 14, fontWeight: 700, fontFamily: FONT_DISPLAY,
        color: HT.brownDark, letterSpacing: 0.5,
      }}>
        Cặp từ - nghĩa này có đúng không?
      </div>

      <div style={{
        padding: 'clamp(20px, 3vw, 32px)',
        background: `linear-gradient(180deg, ${HT.yellowBg} 0%, ${HT.greenBg} 100%)`,
        border: `2px dashed ${HT.yellow}`,
        borderRadius: 22,
        textAlign: 'center',
        minHeight: 260,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        {isGrammarSentence ? (
          <div style={{
            fontSize: 'clamp(20px, 2.6vw, 26px)', fontWeight: 700,
            fontFamily: FONT_DISPLAY, color: HT.text, lineHeight: 1.4,
            fontStyle: 'italic',
          }}>
            "{payload.sentence}"
          </div>
        ) : (
          <>
            {payload.image_url ? (
              <img
                src={payload.image_url}
                alt={payload.word}
                style={{
                  maxHeight: 160, maxWidth: '80%',
                  borderRadius: 14, marginBottom: 14,
                  filter: 'drop-shadow(0 4px 8px rgba(139,111,71,0.15))',
                }}
                onError={(e) => { e.target.style.display = 'none'; }}
              />
            ) : null}
            <div style={{
              fontSize: 'clamp(28px, 4vw, 40px)', fontWeight: 700,
              fontFamily: FONT_DISPLAY, color: HT.text, lineHeight: 1.05,
            }}>
              {payload.word}
            </div>
            <div style={{
              fontSize: 26, color: HT.textMuted, margin: '8px 0',
              fontWeight: 700,
            }}>=</div>
            <div style={{
              fontSize: 'clamp(22px, 3vw, 30px)', fontWeight: 700,
              fontFamily: FONT_DISPLAY, color: HT.coralDark, lineHeight: 1.1,
            }}>
              {payload.shown_meaning_vi}
            </div>
          </>
        )}
      </div>

      <div style={{ display: 'flex', gap: 14, marginTop: 20, justifyContent: 'center' }}>
        <button
          onClick={() => click(false)}
          disabled={isLocked}
          style={tfBtn(submitted === false, truth === false, false)}
        >
          ❌ Sai
        </button>
        <button
          onClick={() => click(true)}
          disabled={isLocked}
          style={tfBtn(submitted === true, truth === true, true)}
        >
          ✅ Đúng
        </button>
      </div>

      {isLocked && payload.explanation_vi ? (
        <div style={{
          marginTop: 16, padding: '14px 16px',
          background: HT.yellowBg, border: `1px solid ${HT.yellow}`,
          borderRadius: 14,
          fontSize: 14, color: HT.text, fontWeight: 600, lineHeight: 1.5,
        }}>
          <span style={{ fontFamily: FONT_DISPLAY, color: HT.brownDark, marginRight: 6 }}>💡 Mẹo:</span>
          {payload.explanation_vi}
        </div>
      ) : null}
    </div>
  );
}

function tfBtn(isPicked, isCorrect, isTrueButton) {
  const isLocked = isPicked || (isPicked === false && isCorrect === false);
  // Default colors per button
  const defaultBg = isTrueButton ? HT.green : HT.coral;
  const defaultShadow = isTrueButton ? HT.greenDark : HT.coralPress;
  let bg = defaultBg;
  let shadow = defaultShadow;
  if (isPicked) {
    bg = isCorrect ? HT.green : HT.coralDark;
    shadow = isCorrect ? HT.greenDark : HT.coralPress;
  }
  return {
    padding: '16px 32px',
    border: 'none',
    borderRadius: 16,
    background: bg,
    color: HT.white,
    fontSize: 18,
    fontWeight: 700,
    fontFamily: FONT_DISPLAY,
    cursor: isLocked ? 'default' : 'pointer',
    boxShadow: `0 4px 0 ${shadow}`,
    minWidth: 160,
    transition: 'transform 0.1s, box-shadow 0.1s',
  };
}
